var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button",attrs:{"href":_vm.appUrl,"target":"_blank","rel":"external"}},[_c('img',{attrs:{"src":_vm.appIcon,"alt":_vm.title}}),_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }